export const SET_USER_DATA = 'APP/SET_USER_DATA';
